// removed by extract-text-webpack-plugin
module.exports = {"successIcon":"UpdateSuccessModal__successIcon___lf4e_","dialogContainer":"UpdateSuccessModal__dialogContainer___3zUwi","baseBtn":"UpdateSuccessModal__baseBtn___3bYUf","secondaryBtn":"UpdateSuccessModal__secondaryBtn___1Zty8","subtitle":"UpdateSuccessModal__subtitle___1hjML","content":"UpdateSuccessModal__content___2q9Q2"};


//////////////////
// WEBPACK FOOTER
// ./src/card/CardDialogs/UpdateSuccessModal/UpdateSuccessModal.scss
// module id = 1222
// module chunks = 0